import styles from './ProgressIndicator.module.css';

export const ProgressIndicator = ({
  value,
  label,
}: {
  value: number;
  label: string;
}) => {
  const clampedValue = Math.max(0, Math.min(1, value));
  const percentage = Math.round(clampedValue * 100);

  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - clampedValue);

  return (
    <div className={styles.progressIndicator}>
      <div className={styles.progressCircle}>
        <svg viewBox="0 0 40 40">
          <circle
            className={styles.progressCircleBg}
            cx="20"
            cy="20"
            r={radius}
          />
          <circle
            className={styles.progressCircleProgress}
            cx="20"
            cy="20"
            r={radius}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
          />
        </svg>
        <span className={styles.progressText}>{percentage}%</span>
      </div>
      <strong className={styles.progressLabel}>{label}</strong>
    </div>
  );
};
